import React from 'react';
import { makeStyles } from 'design-system/styles';
interface FrameSelectorProps {
  x: number;
  opacity?: number;
  frameIndicatorRef?: React.RefObject<SVGSVGElement>;
  height?: number;
  attributeBars?: boolean;
  frameHoverOffset?: number;
  color?: string;
}

const FULL_HEIGHT = 1000;

const FrameSelector = ({
  x,
  opacity = 1,
  frameIndicatorRef,
  height,
  attributeBars,
  frameHoverOffset,
  color,
}: FrameSelectorProps) => {
  const classes = useStyles({ color });
  if (!attributeBars) {
    return (
      <svg ref={frameIndicatorRef} x={`${x}%`} overflow="visible">
        <rect
          y="10"
          width="2"
          height={height ?? '22'}
          // translating here to center the rect as the polygon is based on the center and the rect is based on the left point
          style={{ opacity }}
          className={`${classes.frameBar} ${classes.frameBarCenter}`}
        />
        <polygon points={`-6,0 0,12 6,0`} style={{ opacity }} className={classes.frameBar} />
      </svg>
    );
  } else if (opacity === 1) {
    return (
      <svg x={`${x}%`} overflow="visible">
        <rect
          y={-1 * FULL_HEIGHT}
          width="2"
          height={2 * FULL_HEIGHT}
          style={{ opacity }}
          className={`${classes.frameBar} ${classes.frameBarCenter}`}
        />
      </svg>
    );
  } else if (frameHoverOffset !== -1 && x === -1) {
    return (
      <svg x={`${frameHoverOffset}%`} overflow="visible">
        <rect
          y="13"
          width="2"
          height="8"
          style={{ opacity }}
          className={`${classes.frameBar} ${classes.frameBarCenter}`}
        />
      </svg>
    );
  } else {
    return (
      <svg x={`${x}%`} overflow="visible">
        <rect
          y={-1 * FULL_HEIGHT}
          width="2"
          height={FULL_HEIGHT - 10}
          style={{ opacity }}
          className={`${classes.frameBar} ${classes.frameBarCenter}`}
        />
        {opacity !== 1 && (
          <polygon points={`-6,0 0,12 6,0`} style={{ opacity }} className={classes.frameBar} />
        )}
        <rect
          y="10"
          width="2"
          height={FULL_HEIGHT}
          style={{ opacity }}
          className={`${classes.frameBar} ${classes.frameBarCenter}`}
        />
      </svg>
    );
  }
};

interface StyleProps {
  color?: string;
}

const useStyles = makeStyles(() => ({
  frameBar: {
    fill: (props: StyleProps) => props.color ?? 'black',
    pointerEvents: 'none',
  },
  frameBarCenter: {
    transform: 'translateX(-1px)',
  },
}));

export default FrameSelector;
